import React, { useState } from "react";
import Toast from "react-bootstrap/Toast";

import Header from "../../layout/Header.jsx";

const api = "/api/admin";
const fetchAdminAPI = async (url, requestInit = {}) => {
  const response = await fetch(`${api}/${url}`, {
    method: "POST",
    headers: {
      Authorization: `Basic ${Buffer.from(
        `${process.env.ADMIN_API_BASIC_AUTH_NAME || "dsa8X(*AS("}:${
          process.env.ADMIN_API_BASIC_AUTH_PASS || "S&D*YBwe9H"
        }`
      ).toString("base64")}`,
    },
    ...requestInit,
  });

  let result;
  if (response.headers.get("content-type")?.includes("application/json")) {
    result = await response.json();
  }

  if (!response.ok) {
    throw new Error(result.message || response.statusText);
  }

  if ("success" in result && !result.success) {
    throw new Error(result.message || "Unknown error");
  }

  return result;
};

export default function PageOperations() {
  const [error, setError] = useState(null);
  const [done, setDone] = useState(false);
  const [data, setData] = useState([]);

  return (
    <>
      <div>
        <Header>Operations</Header>
        <div className="row">
          <div className="col border p-2">
            <h5>Kick user from race</h5>
            <form
              onSubmit={async (event) => {
                event.preventDefault();
                const data = new FormData(event.target);

                try {
                  await fetchAdminAPI("kick-from-race", { body: data });
                  setDone(true);
                } catch (error) {
                  setError(error.message);
                }
              }}
            >
              User Address <input type="submut" name="address" />
            </form>
          </div>
        </div>
        <div className="row border">
          <div className="col p-2">
            <h5>List breed on chain</h5>
            <form
              onSubmit={async (event) => {
                event.preventDefault();
                try {
                  const data = await fetchAdminAPI("matched-breeds-on-chain", {
                    method: "GET",
                  });
                  console.log("data", data);
                  setData(data);
                  setDone(true);
                } catch (error) {
                  setError(error.message);
                }
              }}
            >
              <button type="submit">List</button>
            </form>
            <p style={{ overflowWrap: "break-word" }}>
              {JSON.stringify(data)}
            </p>
          </div>
          <div className="col p-2">
            <h5>Reject breed</h5>
            <form
              onSubmit={async (event) => {
                event.preventDefault();
                const data = new FormData(event.target);

                try {
                  await fetchAdminAPI("reject-breed", { body: data });
                  setDone(true);
                } catch (error) {
                  setError(error.message);
                }
              }}
            >
              Breed Address <input type="submut" name="breedAddress" />
            </form>
          </div>
        </div>
        <div className="row">
          <div className="col border p-2">
            <h5>Process training transaction</h5>
            <form
              onSubmit={async (event) => {
                event.preventDefault();
                const data = new FormData(event.target);

                try {
                  await fetchAdminAPI("process-training-transaction", { body: data });
                  setDone(true);
                } catch (error) {
                  setError(error.message);
                }
              }}
            >
              Tx id <input type="submut" name="txId" />
            </form>
          </div>
        </div>
      </div>
      <div className="toast-container">
        <Toast
          className={error ? "error" : ""}
          autohide
          show={!!error || done}
          onClose={() => {
            setError(null);
            setDone(false);
          }}
        >
          <Toast.Body>{error || "The action is completed"}</Toast.Body>
        </Toast>
      </div>
    </>
  );
}
